import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	getUsersAsync,
	deleteUserAsync,
	sharedSwithPortalNav,
	openLoadingDialog,
} from '../../redux/actions';
import { IStore } from '../../schemas';
import {
	UserPanelDetail,
	UserPanelNew,
	UserList,
	UserPagination,
	UserToolbar,
	UserPanelEdit,
} from '../../components';
import './index.scss';
import Modal from '@fluentui/react/lib/Modal';

class Users extends Component<any, any> {
	private _pagination: any = null;
	private _searchParams: any = {};

	state = {
		isDetailOpened: false,
		isPanelNewOpened: false,
		isPanelEditOpened: false,
		selectedRow: {},
		searchText: '',
		page: 1,
	};

	componentDidMount() {
		this.getData();
	}

	searchClick = (data) => {
		const { searchText } = data;
		this._searchParams = { ...data, pageNumber: 1 };
		this._pagination.setState({ page: 1 });
		this.setState({ searchText, page: 1 });
		this.getData();
	};

	pageClick = (page) => {
		this.setState({ page: page });
		this._searchParams = { ...this._searchParams, pageNumber: page };
		this.getData();
	};

	getData = () => {
		this.props.openLoadingDialog({ loadingOpen: true });
		this.props.getUsersAsync(this._searchParams).then(() => {
			this.props.openLoadingDialog({ loadingOpen: false });
		});
	};

	/**
	 * Triggered when option menu is clicked
	 * @param menuKey The key of the option menu item
	 * @param dataItem The data item of select row
	 */
	optionMenuClick = (menuKey, dataItem: any) => {
		console.log('-------------optionMenuClick', menuKey, dataItem);
		switch (menuKey) {
			case 'details':
				this.setState({ isDetailOpened: true, selectedRow: { ...dataItem } });
				break;
			case 'edit':
				this.setState({
					isPanelEditOpened: true,
					selectedRow: { ...dataItem },
				});
				break;
			case 'delete':
				this.props.deleteUserAsync(dataItem);
				break;
			default:
				break;
		}
	};

	closeDetailPanel = (isOpen) => {
		console.log('-------------panel detail dismiss');
		this.setState({ isDetailOpened: isOpen });
	};

	closePanelNew = (isOpen) => {
		console.log('-------------panel new dismiss');
		this.setState({ isPanelNewOpened: isOpen });
	};

	closePanelEdit = (isOpen) => {
		console.log('-------------panel edit dismiss');
		this.setState({ isPanelEditOpened: isOpen });
	};

	switchPortalNavClick = () => {
		console.log('-------------switchPortalNavClick');
		this.props.sharedSwithPortalNav();
	};

	newRecordBtnClick = () => {
		this.setState({ isPanelNewOpened: true });
	};

	render() {
		const { users } = this.props;
		return (
			<>
				<UserToolbar
					onSwitchPortalNavClick={this.switchPortalNavClick}
					onNewRecordBtnClick={this.newRecordBtnClick}
					searchClick={this.searchClick}
				/>

				<UserList
					items={users.data ?? users}
					onOptionMenuClick={this.optionMenuClick}
				/>

				{this.state.isDetailOpened ? (
					<UserPanelDetail
						isOpen={this.state.isDetailOpened}
						detail={this.state.selectedRow}
						onDismiss={this.closeDetailPanel}
					/>
				) : null}

				{this.state.isPanelNewOpened ? (
					<UserPanelNew
						isOpen={this.state.isPanelNewOpened}
						onDismiss={this.closePanelNew}
					/>
				) : null}

				{this.state.isPanelEditOpened ? (
					<UserPanelEdit
						isOpen={this.state.isPanelEditOpened}
						detail={this.state.selectedRow}
						onDismiss={this.closePanelEdit}
					/>
				) : null}

				<UserPagination
					ref={(v) => {
						{
							this._pagination = v;
						}
					}}
					onPageClick={this.pageClick}
					pageCount={this.props.users.total ?? 10}
				/>
			</>
		);
	}
}

export default connect(
	(state: IStore) => ({
		users: state.users,
		sharedPortalNavSwitch: state.sharedPortalNavSwitch,
		common: state.common,
	}),
	{
		sharedSwithPortalNav,
		getUsersAsync,
		deleteUserAsync,
		openLoadingDialog,
	}
)(Users);
